import _ from "lodash";
import config from "./config";
import axios from "./restClient";
import storage from "./storage";
import {
  getAccessToken,
  getRefreshTokenAndEmail,
  setAccessToken,
  setToken,
} from "../../authService";
import { getAccessRefreshToken, getRefreshToken } from "../auth";

const restClient = axios.create();
restClient.interceptors.response.use(
  function (response) {
    // Return a successful response directly

    return response;
  },
  async function (error) {
    // Handle any error responses here
    if (error.response.statusCode === 401) {
      // // Clear any stored authentication tokens or user data
      // storage.clear();
      // localStorage.removeItem("accessToken");
      // localStorage.removeItem("refreshToken");
      // window.location.href = "/login";
      // // Redirect the user to the login page
      // window.location.href = "/login";
      const payload = getRefreshTokenAndEmail();

      const refreshToken = await getAccessRefreshToken(payload);
      if (refreshToken) {
        setToken(refreshToken.accessToken, refreshToken.refreshToken);
        window.location.reload();
      } else {
        window.location.href = "/login";
      }
    }

    // Return any other errors directly
    return Promise.reject(error);
  }
);
class InternalApi {
  static formatUrl(path) {
    if (_.isString(path)) {
      // return `/resource/${path}`;
      return `/${path}`;
    }
    return `/${path.server}${path.path}`;
  }

  static apiUrl(path) {
    if (_.isString(path)) {
      return `${config.apiUrl}resource/${path}`;
    }
    return `${config.apiUrl}${path.server}${path.path}`;
  }

  static get(urlPath, rest = {}) {
    const requestParams = Object.assign({}, rest, {
      method: "GET",
      params: Object.assign({}, rest.params || {}, {
        // token: storage.get('token'),
      }),
      responseType: rest.isFileDownload ? "blob" : "json",
      headers: Object.assign({}, rest.headers || {}, {
        Authorization: `Bearer ${getAccessToken("accessToken")}`,
      }),
    });

    return axios(InternalApi.formatUrl(urlPath), requestParams).then((res) => {
      if (rest.isFileDownload) {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", rest.fileName);
        document.body.appendChild(link);
        link.click();
      }
      return res?.data;
    });
  }

  static post(urlPath, data = {}, headers = {}) {
    const requestParams = {
      method: "POST",
      data: data,
      params: {
        // token: storage.get('token'),
      },
      headers: Object.assign({}, headers, {
        "Content-Type": data.isFileUpload
          ? "multipart/form-data"
          : "application/json",
        Authorization: `Bearer ${getAccessToken("accessToken")}`,
      }),
    };
    return axios(InternalApi.formatUrl(urlPath), requestParams).then(
      (res) => res?.data
    );
  }
  static postImage(urlPath, data = {}, headers = {}) {
    const requestParams = {
      method: "POST",
      data: data,
      params: {
        // token: storage.get('token'),
      },
      headers: Object.assign({}, headers, {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${getAccessToken("accessToken")}`,
      }),
    };
    return axios(InternalApi.formatUrl(urlPath), requestParams).then(
      (res) => res?.data
    );
  }

  static put(urlPath, data = {}, headers = {}) {
    const requestParams = {
      method: "PUT",
      data,
      params: {
        // token: storage.get('token'),
      },
      headers: Object.assign({}, headers, {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getAccessToken("accessToken")}`,
      }),
    };

    return axios(InternalApi.formatUrl(urlPath), requestParams).then(
      (res) => res?.data
    );
  }

  static patch(urlPath, data = {}, headers = {}) {
    const requestParams = {
      method: "PATCH",
      data,
      params: {
        // token: storage.get('token'),
      },
      headers: Object.assign({}, headers, {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getAccessToken("accessToken")}`,
      }),
    };

    return axios(InternalApi.formatUrl(urlPath), requestParams).then(
      (res) => res?.data
    );
  }

  static delete(urlPath, data = {}, headers = {}) {
    const requestParams = {
      method: "DELETE",
      data,
      params: {
        // token: storage.get('token'),
      },
      headers: Object.assign({}, headers, {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getAccessToken("accessToken")}`,
      }),
    };

    return axios(InternalApi.formatUrl(urlPath), requestParams).then(
      (res) => res?.data
    );
  }

  static uploadFile(name, file, options = {}) {
    const data = new FormData();

    data.append(name, file);
    data.append("name", name);
    data.append("options", JSON.stringify(options));

    const requestParams = {
      method: "POST",
      data,
      params: {
        // token: storage.get('token'),
      },
      headers: Object.assign(
        {},
        {
          Authorization: `Bearer ${getAccessToken("accessToken")}`,
        }
      ),
    };

    return axios(
      InternalApi.formatUrl("attachment/upload"),
      requestParams
    ).then((res) => res?.data);
  }

  static uploadAsset(name, file, options = {}) {
    const data = new FormData();

    data.append(name, file);
    data.append("name", name);
    data.append("options", JSON.stringify(options));

    const requestParams = {
      method: "POST",
      data,
      params: {
        // token: storage.get('token'),
      },
      headers: Object.assign(
        {},
        {
          Authorization: `Bearer ${getAccessToken("accessToken")}`,
        }
      ),
    };

    return axios(InternalApi.formatUrl("asset/upload"), requestParams).then(
      (res) => res?.data
    );
  }
}

export default InternalApi;
